import '.u{position:absolute;}.ssr-plugin'
import '.je{color:rgba(0,0,0,0.4);}.ssr-plugin'
import '.jf{height:16px;}.ssr-plugin'
import '.jg{width:16px;}.ssr-plugin'
import '.a0{border-radius:50%;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.en{flex-grow:1;}.ssr-plugin'
import '.am{overflow:hidden;}.ssr-plugin'
import '.jh{transform:translate3d(0,0,0);}.ssr-plugin'
import '.ji{height:284px;}.ssr-plugin'
import { useRef } from 'react'
import { styled } from 'inlines'
import { rgbToXY, xyToRgb } from './utils.js'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'

type RgbPickerProps = {
  hue: [number, number, number]
  rgb: [number, number, number]
  onChange: (rgb: [number, number, number]) => void
  style?: React.CSSProperties
}

const Absolute = styled('div', {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
})

const GradientX = styled(Absolute, {
  background:
    'linear-gradient(to right, rgb(255, 255, 255), rgba(255, 255, 255, 0))',
})

const GradientY = styled(Absolute, {
  background: 'linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0))',
})

export const Pointer = ({ x, y }: { x: number; y: number }) => {
  return (
    <div className="u"
      style={{
        left: `${x * 100}%`,
        top: `${y * 100}%`,
        transform: `translate3d(-50%,-50%,0)`,
      }}
    >
      <div className="je jf jg a0"
        style={{
          border: `2px solid ${colors.white100}`,
          boxShadow: `0px 0px 4px ${colors.black60}, inset 0px 0px 4px ${colors.black60}`,}}
      />
    </div>
  )
}

export const RgbPicker = ({ hue, rgb, onChange, style }: RgbPickerProps) => {
  const { x, y } = rgbToXY(rgb, hue)
  const xRef = useRef(x)

  const onDown = (e: React.MouseEvent<HTMLDivElement>) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect()

    const onMove = ({
      clientX,
      clientY,
    }: {
      clientX: number
      clientY: number
    }) => {
      let x = (clientX - left) / width
      let y = (clientY - top) / height

      if (x > 1) x = 1
      if (x < 0) x = 0
      if (y > 1) y = 1
      if (y < 0) y = 0

      const rgb = xyToRgb(x, y, hue)
      xRef.current = x
      onChange(rgb as [number, number, number])
    }

    const onUp = (e: React.MouseEvent<HTMLDivElement>) => {
      onMove(e)
      removeEventListener('mousemove', onMove)
      removeEventListener('mouseup', onUp as any)
    }

    addEventListener('mousemove', onMove)
    addEventListener('mouseup', onUp as any)

    onMove(e)
  }

  return (
    <styled.div className="s f en am jh ji"
      onMouseDown={onDown}
      style={{
        background: `rgb(${hue.join(',')})`,
        borderRadius: radius[12],
        outline: `1px solid ${colors.neutral20Adjusted}`,
        ...style,
      }}
    >
      <GradientX>
        <GradientY>
          <Pointer x={y === 1 ? xRef.current : x} y={y} />
        </GradientY>
      </GradientX>
    </styled.div>
  )
}
